module.exports = __webpack_public_path__ + "img/close.5413bfa5.png";